import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import Modal from '../../../components/Modal/Modal';
import { AppButton } from '../../../components/UI';
import { toCrmForm } from '../constants';
import DuplicateCandidates, { useDuplicateCheck } from '../../../components/DuplicateCandidates/DuplicateCandidates';

const FIELDS = [
  { key: 'linkedin', label: 'LinkedIn', full: true },
  { key: 'prenom', label: 'Prénom' },
  { key: 'nom', label: 'Nom' },
  { key: 'fonction', label: 'Fonction' },
  { key: 'employeur', label: 'Employeur actuel' },
  { key: 'email', label: 'Email' },
  { key: 'telephone', label: 'Téléphone' },
  { key: 'localisation', label: 'Localisation' },
  { key: 'date_debut', label: 'Année de début (poste actuel)' },
  { key: 'sachez_que', label: 'Sachez que (résumé du profil)', full: true, multiline: true },
  { key: 'competences', label: 'Compétences', full: true, multiline: true },
];

/** Pre-filled form to create a sourced candidate in the CRM. */
const AddToCrmDialog = ({ item, busy, onClose, onSubmit }) => {
  const [form, setForm] = useState(() => (item ? toCrmForm(item) : {}));

  useEffect(() => {
    if (item) setForm(toCrmForm(item));
  }, [item]);

  const duplicates = useDuplicateCheck(
    { linkedin: form.linkedin, prenom: form.prenom, nom: form.nom, employeur: form.employeur },
    !!item,
  );
  const submitLabel = duplicates.sameProfile ? 'Mettre à jour la fiche' : duplicates.hasSimilar ? 'Créer quand même' : 'Créer le candidat';

  return (
    <Modal
      open={!!item}
      onClose={() => !busy && onClose()}
      maxWidth="sm"
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Box sx={{ width: 38, height: 38, borderRadius: '10px', bgcolor: '#ebf4fb', color: '#03407b', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <PersonAddAlt1OutlinedIcon />
          </Box>
          <Box>
            <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>Ajouter au CRM</Typography>
            <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>Informations extraites de LinkedIn : vérifiez-les avant de créer le candidat.</Typography>
          </Box>
        </Box>
      }
      actions={
        <>
          <AppButton variant="secondary" onClick={onClose} disabled={busy}>Annuler</AppButton>
          <AppButton startIcon={<PersonAddAlt1OutlinedIcon />} loading={busy} disabled={(!form.nom && !form.prenom) || duplicates.loading} onClick={() => onSubmit(form)}>
            {submitLabel}
          </AppButton>
        </>
      }
    >
      <Box sx={{ mb: 2 }}><DuplicateCandidates check={duplicates} /></Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1.75, pt: 0.5 }}>
        {FIELDS.map((f) => (
          <Box key={f.key} sx={{ gridColumn: f.full ? '1 / -1' : 'auto' }}>
            <Typography component="label" sx={{ display: 'block', mb: 0.6, fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: '#64748b' }}>
              {f.label}
            </Typography>
            <TextField
              fullWidth
              size="small"
              multiline={!!f.multiline}
              maxRows={4}
              value={form[f.key] || ''}
              placeholder={f.key === 'email' || f.key === 'telephone' ? 'Non visible sur LinkedIn' : ''}
              onChange={(e) => setForm((p) => ({ ...p, [f.key]: e.target.value }))}
              disabled={busy}
            />
          </Box>
        ))}
      </Box>
      <Typography sx={{ mt: 1.5, fontSize: '0.74rem', color: '#94a3b8' }}>
        La vérification porte sur le LinkedIn, puis sur le nom et l'entreprise. Modifiez les champs : elle se relance automatiquement.
      </Typography>
    </Modal>
  );
};

export default AddToCrmDialog;
